import React from "react";
import { VoterDashboardList } from "./VoterSearch";

// Voter Management > Dashboard - shows the full voter list immediately on
// load (filters, table, booth banner, stats bar, pagination, full toolbar),
// matching the old monolithic FullVoter.js's default behavior. Reuses the
// same view as Voter Search, just without the search-first gate (see
// VoterListView in VoterSearch.js) - Voter Search still requires clicking
// Search first, per the restructure spec.
export const VoterDashboard = () => <VoterDashboardList />;
